import _ from 'lodash';
import {combineReducers} from 'redux';

import StatusBox from 'components/StatusBox';

import {default as listReducer} from './list';
import {default as detailReducer} from './detail';
import {default as trackerReducer} from './tracker';

const reducer = combineReducers({
  list: listReducer,
  detail: detailReducer,
  tracker: trackerReducer
});

export const KYC_STATUSES_COLORS = {
  verified: StatusBox.GREEN,
  pending: StatusBox.ORANGE,
  failed: StatusBox.RED,
  expired: StatusBox.RED
};

export const VALID = 'valid';
export const UNKNOWN = 'n/a';
export const PENDING = 'pending';
export const DOCUMENT_REQUESTED = 'document_requested';
export const EXPIRED = 'expired';

export const KYC_SECTION_STATUSES = {
  [VALID]: {
    label: 'Valid',
    color: StatusBox.GREEN
  },
  [PENDING]: {
    label: 'Pending',
    color: StatusBox.ORANGE
  },
  [DOCUMENT_REQUESTED]: {
    label: 'Document Requested',
    color: StatusBox.ORANGE
  },
  [EXPIRED]: {
    label: 'Expired',
    color: StatusBox.RED
  },
  [UNKNOWN]: {
    label: 'Unknown',
    color: StatusBox.BLUE
  }
};

export const getKycSectionStatus = status =>
  _.get(KYC_SECTION_STATUSES, status, {
    label: 'N/A',
    color: StatusBox.BLUE
  });

export const BOOKING_TYPE = {
  CORPORATE: 'Corporate',
  GUEST: 'Guest',
  LONG_STAY: 'Long Stay',
  EXTENDED_STAY: 'Extended Stay'
};

export const KYC_SECTION_TYPES = {
  POID: 'POID',
  POA: 'POA',
  VISA: 'VISA'
};

export const KYC_SECTIONS_META = {
  [KYC_SECTION_TYPES.POID]: {
    SIDEBAR_HEADING: 'Identification',
    NAVIGATION_HEADING: 'ID',
    VERBOSE: 'Proof of ID'
  },
  [KYC_SECTION_TYPES.POA]: {
    SIDEBAR_HEADING: 'Proof of address',
    NAVIGATION_HEADING: 'Address',
    VERBOSE: 'Proof of Address'
  },
  [KYC_SECTION_TYPES.VISA]: {
    SIDEBAR_HEADING: 'Visa',
    NAVIGATION_HEADING: 'Visa',
    VERBOSE: 'Visa'
  }
};

export const MODALS = {
  ADD_AGREEMENT: 'addAgreement',
  CREATE_OFFER: 'createOffer',
  SEND_AGREEMENT: 'sendAgreement',
  LEGACY_DOCUMENT_UPLOAD: 'legacyDocumentUpload',
  AFFORDABILITY_DETAIL: 'affordabilityDetail',
  AFFORDABILITY_DOCUMENT_UPLOAD: 'affordabilityDocumentUpload',
  KYC: 'kyc',
  KYC_DOCUMENT_UPLOAD: 'kycDocumentUpload',
  KYC_VERIFY_VISA: 'kycVerifyVisa',
  CREATE_RENT_SCHEDULE: 'createRentSchedule',
  ADD_GUARANTOR: 'addGuarantorModal',
  ADD_EMPLOYMENT: 'addEmployment',
  CANCEL_BOOKING: 'cancelBooking',
  AGREEMENT_DETAIL: 'agreementDetail',
  SEND_AGREEMENT_REMINDER: 'sendAgreementReminder',
  SIGN_AGREEMENT_MANUALLY: 'signAgreementManually',
  REQUEST_KYC_DOCUMENT: 'requestKycDocument',
  ADD_SECONDARY_TENANT: 'addSecondaryTenant',
  REMOVE_SECONDARY_TENANT: 'removeSecondaryTenant',
  LEGACY_DOCUMENT_EDIT: 'legacyDocumentEdit',
  ADDRESS_HISTORY: 'addressHistory',
  CONFIRM_CHARGE: 'confirmCharge',
  CREATE_DRAFT_INVOICE: 'createDraftInvoice',
  DRAFT_INVOICE_DETAIL: 'draftInvoiceDetail'
};

export const BOOKING_REQUEST_API = 'Application Form';
export const RENEWAL_FORM = 'Renewal Form';

export const BOOKING_STATUSES = {
  CANCELLED: 'Cancelled',
  OVERSTAY: 'Overstay',
  DUE_OUT: 'Due out',
  IN_HOUSE: 'In house',
  CHECKED_OUT: 'Checked out',
  NO_SHOW: 'No show',
  DUE_IN: 'Due in',
  RESERVED: 'Reserved',
  CONFIRMED: 'Confirmed',
  QUALIFIED: 'Qualified'
};

const BOOKING_STATUS_GROUPS = {
  IN_THE_BUILDING: 'In the building',
  UPCOMING: 'Upcoming',
  VOID_DELETED: 'Void/ deleted',
  CHECKED_OUT: 'Checked out'
};

const BOOKING_STATUS_GROUP_TO_BOOKING_STATUSES = {
  [BOOKING_STATUS_GROUPS.IN_THE_BUILDING]: [
    BOOKING_STATUSES.IN_HOUSE,
    BOOKING_STATUSES.DUE_OUT,
    BOOKING_STATUSES.OVERSTAY
  ],
  [BOOKING_STATUS_GROUPS.UPCOMING]: [
    BOOKING_STATUSES.DUE_IN,
    BOOKING_STATUSES.RESERVED,
    BOOKING_STATUSES.CONFIRMED,
    BOOKING_STATUSES.QUALIFIED,
    BOOKING_STATUSES.NO_SHOW
  ],
  [BOOKING_STATUS_GROUPS.VOID_DELETED]: [BOOKING_STATUSES.CANCELLED],
  [BOOKING_STATUS_GROUPS.CHECKED_OUT]: [BOOKING_STATUSES.CHECKED_OUT]
};

export const getBookingStatusGroups = (): Array<string> => {
  return Object.keys(BOOKING_STATUS_GROUPS).map(
    key => BOOKING_STATUS_GROUPS[key]
  );
};

export const getBookingStatusesForStatusGroup = (
  bookingStatusGroup: string
): Array<string> => {
  return _.get(
    BOOKING_STATUS_GROUP_TO_BOOKING_STATUSES,
    bookingStatusGroup,
    []
  );
};

export const BOOKING_TYPE_TO_PURPOSE_TYPE_MAPPER = {
  ['Long Stay']: 'long_stay',
  ['Extended Stay']: 'extended_stay',
  ['Corporate']: 'corporate',
  ['Guest']: 'guest'
};

export default reducer;
export * from './list';
export * from './detail';
export * from './tracker';
